import { render, staticRenderFns } from "./TextSlideContent.vue?vue&type=template&id=d85c2d2e&scoped=true&"
import script from "./TextSlideContent.vue?vue&type=script&lang=js&"
export * from "./TextSlideContent.vue?vue&type=script&lang=js&"
import style0 from "./TextSlideContent.vue?vue&type=style&index=0&id=d85c2d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85c2d2e",
  null
  
)

export default component.exports